import Box from "../../components/Box";
import Text from "../../components/Text";

const points = [
    { icon: "", text: "How AI can handle parent messages 24×7 automatically" },
    { icon: "", text: "Real stories from school owners who already use SooMuch.ai" },
    { icon: "", text: "How to make report cards and progress updates faster" },
    { icon: "", text: "Step-by-step guide to start in under 10 minutes" },
    { icon: "", text: "How schools use WhatsApp to teach and connect" }
];

export default function WhatYouWillLearn() {

    return (
        <Box
            badge={"Tutorial"}
            title={"What you will learn"}
            leftBlock={
                <div className='col-span-2 md:col-span-1 bg-[white] p-7'>
                    <div className="grid grid-cols-2 md:grid-cols-1 gap-6">
                        {points.map((section, index) => (
                            <div key={"asdasdasdasdasd"+index} className="flex items-center gap-2">
                                <div className="md:hidden w-2 h-2 bg-blue-600 rounded-full" />
                                <Text label={section?.text} cName="text-gray-700 text-sm leading-relaxed" />
                            </div>
                        ))}
                    </div>
                </div>
            }
        />
    );
}